import React from 'react';
import { Lock, ArrowRight } from '@phosphor-icons/react';
import clsx from 'clsx';
import { useAdminContext } from '@/contexts/AdminContext';

const SubscriptionExpired: React.FC = () => {
  const { modal } = useAdminContext();

  return (
    <div className="min-h-[calc(100vh-160px)] flex items-center justify-center">
      <div className="w-full max-w-xl">
        <div className="bg-white rounded-3xl border border-gray-100 shadow-sm overflow-hidden">
          <div className="px-8 pt-10 pb-8 text-center">
            <div className="mx-auto w-12 h-12 rounded-2xl bg-[#1A162F]/10 text-[#1A162F] flex items-center justify-center mb-4">
              <Lock size={22} weight="bold" />
            </div>

            <h1 className="text-2xl font-bold text-[#1A162F] mb-2">Your subscription has expired</h1>
            <p className="text-sm text-gray-600 leading-relaxed">
              To view dashboards or create new ones, please renew your plan.
            </p>
          </div>

          <div className="px-8 pb-8">
            <div className="rounded-2xl bg-gray-50 border border-gray-100 p-5">
              <div className="grid gap-3">
                {[
                  'Existing dashboards are temporarily locked.',
                  'Creating new dashboards is unavailable on an expired plan.',
                ].map((text) => (
                  <div key={text} className="flex items-center gap-3">
                    <div className="w-2 h-2 rounded-full bg-[#1A162F]" />
                    <div className="text-sm text-gray-700 leading-relaxed">{text}</div>
                  </div>
                ))}
              </div>
              <div className="mt-4 text-xs text-gray-500 leading-relaxed">
                Renew anytime to restore access.
              </div>
            </div>
          </div>

          <div className="px-8 pb-10">
            <button
              type="button"
              onClick={() => modal.openModal('pricing')}
              className={clsx(
                "w-full py-3 rounded-full font-bold transition-all duration-200 text-base tracking-wide",
                "bg-[#1A162F] text-white hover:bg-black shadow-lg hover:shadow-xl hover:-translate-y-0.5",
                "flex items-center justify-center gap-2"
              )}
            >
              Choose a plan
              <ArrowRight size={18} weight="bold" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionExpired;
